import ReactRailsUJS from 'react_ujs'
import { setReactConstructor } from '../helpers/ViteHelper'

const modules = import.meta.glob([
  '~/pages/**/*.{js,jsx,ts,tsx}',
  '~/partials/**/*.{js,jsx,ts,tsx}',
], { eager: true })

setReactConstructor(ReactRailsUJS, modules)
